import React, { useState } from "react";

import { Link } from "react-router-dom";
import { Heart, Loader } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToWishlist,
  fetchWishlist,
  removeFromWishlist,
} from "../../Redux/WishlistSlice";
import { api } from "../../api/api";
import { Wish } from "../../api/urls";
import { toast } from "react-toastify";
import { handleAuthModal } from "../../Redux/Auth";

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const wishlist = useSelector((state) => state.wishlist);
  const accessToken = useSelector((state) => state.auth.accessToken);

  const image = product?.inventory?.[0]?.images?.[0]?.img || "";
  const price =
    product?.inventory?.[0]?.size_and_price?.[0]?.product_price || "N/A";

  const [isWishlisted, setIsWishlisted] = useState(
    wishlist?.some((item) => item?.product === product?.id),
  );
  const [loading, setLoading] = useState(false);
  const wishID = wishlist?.find((item) => item?.product === product?.id)?.id;

  const handleWishlistClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!accessToken) return dispatch(handleAuthModal(true));

    try {
      setLoading(true);
      if (isWishlisted) {
        await api.delete(`${Wish}${wishID}/`);
        dispatch(removeFromWishlist(wishID));
        toast.success("Removed from wishlist");
      } else {
        const res = await api.post(Wish, { product: product.id });
        dispatch(addToWishlist(res?.data));
        toast.success("Added to wishlist");
      }

      dispatch(fetchWishlist());
      setIsWishlisted(!isWishlisted);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Link
      to={`/products/${product?.id}`}
      className="border group relative flex flex-col rounded-xl bg-white shadow-sm
    transition md:hover:shadow-xl md:hover:-translate-y-0.5 h-fit"
    >
      {/* Wishlist */}
      <button
        onClick={handleWishlistClick}
        disabled={loading}
        className="
      absolute right-2 top-2 z-10 grid place-content-center
      h-9 w-9 rounded-full bg-white shadow
      transition hover:bg-gray-100
    "
      >
        {loading ? (
          <Loader className="animate-spin" />
        ) : (
          <Heart
            size={20}
            className={
              isWishlisted ? "text-red-500 fill-red-500" : "text-gray-500"
            }
          />
        )}
      </button>

      {/* Image stays square */}
      <div className="w-full aspect-square bg-gray-50 overflow-hidden rounded-t-xl">
        <img
          src={image}
          alt={product?.title}
          className="h-full w-full object-cover transition group-hover:scale-[1.02]"
        />
      </div>

      {/* Content fills the remaining height */}
      <div className="px-3 py-2 sm:px-4 sm:py-3">
        <div>
          {/* <p className="text-[10px] sm:text-xs font-medium text-amber-600">
            FEW ITEMS LEFT
          </p> */}

          <h3
            className="
          text-sm sm:text-base font-semibold text-gray-800
          line-clamp-2 mt-1 truncate
        "
          >
            {product?.title}
          </h3>
        </div>

        <div className="mt-2">
          <p className="text-sm sm:text-base font-semibold text-black">
            ₹ {price}
          </p>

          <p className="text-[10px] text-gray-500">MRP incl. of all taxes</p>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
